export default __webpack_public_path__ + "static/bg-1d9e8c5e0eb8785769b7be874703c984.webp";